export enum AccessControlCompanyTemplateTypesEnum {
    CONTRACT = 1,
    CLIENT = 2
}
